<template>
  <div>
    <v-select
      class="pb-2"
      v-model="address.field1.value"
      :label="address.field1.label"
      :placeholder="address.field1.placeholder"
      :items="address.field1.items"
      :rules="address.field1.rules"
      :error-messages="address.field1.errorMsg"
      menu-props="auto"
      readonly
      disabled
      outlined
      dense
    >
    </v-select>
    <v-select
      class="pb-2"
      v-model="address.field2.value"
      :label="address.field2.label"
      :placeholder="address.field2.placeholder"
      :items="address.field2.items"
      :rules="address.field2.rules"
      :error-messages="address.field2.errorMsg"
      outlined
      dense
    >
    </v-select>
    <v-row>
      <v-col>
        <v-select
          class="pb-2"
          v-model="address.field3.value"
          :label="address.field3.label"
          :placeholder="address.field3.placeholder"
          :items="address.field3.items"
          :rules="address.field3.rules"
          :error-messages="address.field3.errorMsg"
          outlined
          dense
        >
        </v-select
      ></v-col>
      <v-col>
        <v-text-field
          class="pb-2"
          v-model="address.field4.value"
          :label="address.field4.label"
          :placeholder="address.field4.placeholder"
          :rules="address.field4.rules"
          :error-messages="address.field4.errorMsg"
          outlined
          dense
        >
        </v-text-field
      ></v-col>
    </v-row>
    <v-textarea
      id="address"
      class="pb-2"
      v-model="address.field5.value"
      :label="address.field5.label"
      :placeholder="address.field5.placeholder"
      :rules="address.field5.rules"
      :error-messages="address.field5.errorMsg"
      @focus="ScrollTo('address')"
      rows="1"
      hide-details
      outlined
      >address
    </v-textarea>
  </div>
</template>

<script>
import Cities from "@/assets/taiwan_districts.json";
const towns = Cities.map((x) => x.name);
const dic = {};
for (let i = 0; i < towns.length; i++) {
  dic[towns[i]] = Cities[i].areas.map((x) => x.name);
}

export default {
  props: {
    originalAddress: String,
  },
  data() {
    return {
      tempAddress: "",
      address: {
        show: false,
        title: "公司單位地址 ",
        confirm: "確定",
        close: "關閉",
        value: "",
        field1: {
          label: "國家",
          placeholder: "",
          items: [],
          value: "",
          tempValue: "",
          rules: [],
          errorMsg: "",
        },
        field2: {
          label: "城市",
          placeholder: "",
          items: [],
          value: "",
          tempValue: "",
          rules: [],
          errorMsg: "",
        },
        field3: {
          label: "區",
          placeholder: "",
          items: [],
          value: "",
          tempValue: "",
          rules: [],
          errorMsg: "",
        },
        field4: {
          label: "郵遞區號",
          placeholder: "",
          value: "",
          tempValue: "",
          rules: [],
          errorMsg: "",
        },
        field5: {
          label: "街道地址",
          placeholder: "",
          value: "",
          tempValue: "",
          rules: [],
          errorMsg: "",
        },
      },
    };
  },
  mounted() {
    this.SetDefauleAddress();
  },
  watch: {
    originalAddress(val) {
      if (!val || val === "") this.SetDefauleAddress();
      else {
        this.tempAddress = this.originalAddress.split(" ");
        this.address.field1.value = this.tempAddress[0];
        this.address.field2.value = this.tempAddress[1];
        this.address.field3.value = this.tempAddress[2];
        this.address.field5.value = this.tempAddress[3];
      }
    },
    "address.field2.value"() {
      // 依城市改行政區
      this.address.field3.items = dic[this.address.field2.value];
      if (!this.tempAddress) {
        this.address.field3.value = this.address.field3.items[0];
      }
    },
    "address.field3.value"() {
      // 依行政區改郵遞區號
      Cities.find((x) => {
        if (x.name === this.address.field2.value) {
          x.areas.find((y) => {
            if (y.name === this.address.field3.value)
              this.address.field4.value = y.zip;
          });
        }
      });
      this.FormatAddress();
    },
    "address.field5.value"() {
      this.FormatAddress();
    },
  },
  methods: {
    //#region 預設地址
    SetDefauleAddress() {
      this.address.field1.items.push("台灣");
      this.address.field1.value = "台灣";

      this.address.field2.items = towns;
      this.address.field2.value = towns[0];
    },
    //#endregion
    //#region 我來組成地址全部
    FormatAddress() {
      this.address.value =
        `${this.address.field1.value} ` +
        `${this.address.field2.value} ` +
        `${this.address.field3.value} ` +
        `${this.address.field5.value}`;
      this.$emit("address", this.address.value);
    },
    //#endregion

    // 滾動到指定id
    ScrollTo(id) {
      document.getElementById(id).scrollIntoView({ behavior: "smooth" });
    },
  },
};
</script>

<style scoped></style>
